import { useState } from 'react';
import { api } from '../api';
import { useApi } from '../lib/useApi';
import { Card, Empty, ErrorState, Loading } from '../components/ui';
import { fmtDate, n0 } from '../lib/format';
import UserDrawer from './UserDrawer';

const FILTERS = [
  ['all', 'все'], ['owner', 'владельцы'], ['multi', 'в нескольких РП'],
  ['pending', 'приглашены, не вошли'], ['idle', 'молчат >30 дней'], ['blocked', 'заблокированы'],
];

export default function People({ nonce }) {
  const [filter, setFilter] = useState('all');
  const [q, setQ] = useState('');
  const [openId, setOpenId] = useState(null);
  const { data, loading, error, reload } = useApi(() => api.users({ filter, q }), [filter, q, nonce]);

  return (
    <>
      <div className="filters">
        {FILTERS.map(([k, label]) => (
          <button key={k} className={`chip${filter === k ? ' on' : ''}`} onClick={() => setFilter(k)}>{label}</button>
        ))}
        <input className="search" placeholder="почта, имя или пространство" value={q} onChange={(e) => setQ(e.target.value)} />
        {data ? <span className="count">{n0(data.total)} из {n0(data.grandTotal)}</span> : null}
      </div>

      {loading ? <Loading what="людей" />
        : error ? <ErrorState error={error} onRetry={reload} />
        : (
          <Card className="tablecard">
            <table>
              <thead>
                <tr>
                  <th>человек</th><th>пространство</th><th>роль</th>
                  <th className="num">комментариев</th><th className="num">регистрация</th>
                  <th className="num">активность</th><th>триал</th>
                </tr>
              </thead>
              <tbody>
                {data.items.map((u) => {
                  const main = (u.organizations || [])[0];
                  return (
                    <tr key={u.id} onClick={() => setOpenId(u.id)}>
                      <td>
                        <div className="t-name">
                          {u.firstName} {u.lastName} {u.blocked ? <span className="badge b-blocked">заблокирован</span> : null}
                        </div>
                        <div className="t-sub">{u.email}</div>
                      </td>
                      <td>
                        {main ? main.title : <span className="muted">нет пространства</span>}
                        {u.organizations && u.organizations.length > 1 ? (
                          <div className="t-sub">и ещё: {u.organizations.slice(1).map((r) => r.title).join(', ')}</div>
                        ) : null}
                      </td>
                      <td>
                        {main ? (
                          <span className={`badge ${main.role === 'OWNER' ? 'b-active' : 'b-expired'}`}>
                            {main.role === 'OWNER' ? 'владелец' : 'редактор'}
                          </span>
                        ) : null}
                        {main && main.status === 'PENDING' ? <div className="t-sub">не принял приглашение</div> : null}
                      </td>
                      <td className="num">{n0(u.comments)}</td>
                      <td className="num muted" style={{ fontSize: 12 }}>{fmtDate(u.createdAt)}</td>
                      <td className="num muted" style={{ fontSize: 12 }}>{u.lastActivityAt ? fmtDate(u.lastActivityAt) : '—'}</td>
                      <td className="muted" style={{ fontSize: 12 }}>{u.trialUsedAt ? 'использован' : 'доступен'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {data.items.length ? null : <Empty>под эти условия никто не подошёл</Empty>}
          </Card>
        )}

      <UserDrawer id={openId} onClose={() => setOpenId(null)} />
    </>
  );
}
